import React, { createContext, useContext } from "react";
import { useSetupProgress } from "./useSetupProgress";

/**
 * Single shared instance of the setup progress so the floating SetupGuide and
 * the Dashboard SetupCard read the same state (no duplicate API calls, and a
 * toggle in one updates the other live). Provider mounted once near the app root.
 */
const SetupProgressContext = createContext(null);

export function SetupProgressProvider({ children }) {
  const value = useSetupProgress();
  return (
    <SetupProgressContext.Provider value={value}>
      {children}
    </SetupProgressContext.Provider>
  );
}

export function useSetupProgressContext() {
  return useContext(SetupProgressContext);
}
